<template>
	<v-dialog v-model="dialog" persistent max-width="500px">
		<v-card>
			<v-toolbar flat dense cad>
				<v-toolbar-title class="subheading">Choose a Template</v-toolbar-title>
				<v-spacer></v-spacer>
			</v-toolbar>

			<v-card-text>
				<v-list>
					<v-list-group v-for="item in items" :key="item.title" v-model="item.active" :prepend-icon="item.action" no-action>
						<v-list-tile slot="activator">
							<v-list-tile-content>
								<v-list-tile-title>{{ item.title }}</v-list-tile-title>
							</v-list-tile-content>
						</v-list-tile>

						<v-list-tile v-for="subItem in item.items" :key="subItem.title" @click="selectPosition(subItem)">
							<v-list-tile-content>
								<v-list-tile-title>{{ subItem.title }}</v-list-tile-title>
							</v-list-tile-content>

							<v-list-tile-action>
								<v-icon>{{ subItem.action }}</v-icon>
							</v-list-tile-action>
						</v-list-tile>
					</v-list-group>
				</v-list>
			</v-card-text>

			<v-divider></v-divider>

			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn @click="closeSelector">Cancel</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
	export default {
		props: {
			positionTemplates: {
				required: true,
				type: Array
			},
			dialog: {}
		},
		computed: {
			items() {
				let groupedByDept = _.groupBy(this.positionTemplates, 'department');
				let result = [];

				for (let dept in groupedByDept) {
					result.push({
						action: 'domain',
						active: true,
						title: dept !== 'null' ? dept : 'N/A',
						items: groupedByDept[dept]
					});
				}

				return result;
			}
		},
		methods: {
			selectPosition(position) {
				this.$emit('onSelectPositionTemplate', position);
			},
			closeSelector() {
				this.$emit('onCloseSelector');
			}
		}
	};
</script>

<style></style>
